import DownloadButton from "../DownloadButton";
import { capitalizeFirstLetterOfEachWord } from "../../utils/Formatter";
import ProfilePlaceholder from "../../assets/svgIcons/ProfilePlaceholder.svg";
import "../../styles/components/transactionPrintLayouts/POInvoiceLayout.css";
import "../../styles/components/transactionPrintLayouts/MRMInvoiceLayout.css";
export const MRMInvoiceLayout = ({
  headDetails,
  companyData,
  itemDetails,
  rowData,
  invoiceTableData,
  selectedReportName,
}) => {
  const path = window.location.pathname.split("/").filter(Boolean);
  const transactionName = selectedReportName || path[1];
  const organizationData = JSON.parse(localStorage.getItem("organisation"));
  const formatDate = (dateStr) => {
    if (!dateStr) return "--";
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  };
  const formatDateForIntro = (dateStr) => {
    if (!dateStr) return "--";
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };
  const visibleFields = [...rowData]
    .filter((field) => !field.is_internal_field)
    .reverse();
  const meetingRefNo =
    headDetails?.meeting_ref_no || headDetails?.meeting_ref_number || "N/A";
  const dateOfMeeting =
    headDetails?.date_of_meeting ||
    headDetails?.meeting_date ||
    headDetails?.date ||
    headDetails?.created_at;
  const reviewPeriod = headDetails?.review_period || "N/A";
  const membersPresent = headDetails?.members_present || "N/A";
  const membersAbsent =
    headDetails?.members_absent || headDetails?.members_absent_value || "N/A";
  const introDate = headDetails?.intro_date || dateOfMeeting;
  const getMeetingNumber = () => {
    if (headDetails?.meeting_number) {
      return headDetails.meeting_number;
    }

    if (meetingRefNo && meetingRefNo !== "N/A") {
      const match = meetingRefNo.match(/(\d+)/);
      if (match) {
        const num = parseInt(match[1]);
        const suffixes = [
          "",
          "ST",
          "ND",
          "RD",
          "TH",
          "TH",
          "TH",
          "TH",
          "TH",
          "TH",
          "TH",
        ];
        const suffix = num <= 10 ? suffixes[num] || "TH" : "TH";
        return `${num}${suffix}`;
      }
    }
    return null;
  };
  const meetingNumber = getMeetingNumber();
  const meetingTime = headDetails?.meeting_time || headDetails?.time || null;
  const docRef =
    headDetails?.doc_ref || headDetails?.document_reference || "FP/F/MR/12";
  const pageInfo = headDetails?.page_info || headDetails?.page_number || null;
  return (
    <div className="mrm-invoice-container">
      <div className="mrm-header">
        <div className="mrm-header-left">
          <div className="mrm-logo-container">
            <img
              src={organizationData?.logo_url || ProfilePlaceholder}
              alt="Logo"
              className="mrm-logo-content"
            />
          </div>
          <div className="mrm-company-name-left">
            {organizationData?.name?.toUpperCase() || "FINE PUNCH FAB PVT LTD"}
          </div>
        </div>
        <div className="mrm-header-separator"></div>
        <div className="mrm-header-center">
          <div className="mrm-company-name">
            {organizationData?.name?.toUpperCase() ||
              "FINE PUNCH FAB PRIVATE LIMITED"}
          </div>
          <div className="mrm-header-horizontal-separator"></div>
          <div className="mrm-document-title">
            MINUTES OF MANAGEMENT REVIEW MEETINGS
          </div>
        </div>
      </div>
      <div className="mrm-meeting-details-table">
        <table className="mrm-details-table">
          <tbody>
            <tr>
              <td className="mrm-detail-label">Meeting Ref No</td>
              <td className="mrm-detail-value">{meetingRefNo}</td>
            </tr>
            <tr>
              <td className="mrm-detail-label">Date of Meeting</td>
              <td className="mrm-detail-value">{formatDate(dateOfMeeting)}</td>
            </tr>
            <tr>
              <td className="mrm-detail-label">Review Period</td>
              <td className="mrm-detail-value">{reviewPeriod}</td>
            </tr>
            <tr>
              <td className="mrm-detail-label">Members Present</td>
              <td className="mrm-detail-value">{membersPresent}</td>
            </tr>
            <tr>
              <td className="mrm-detail-label">Members Absent</td>
              <td className="mrm-detail-value">{membersAbsent}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="mrm-intro-text">
        {meetingNumber ? `The ${meetingNumber.toUpperCase()} ` : "The "}
        Management Review Meeting as per ISO 9001:2015 Held on{" "}
        {formatDateForIntro(introDate)}
        {meetingTime ? ` at ${meetingTime}` : ""}. MD chaired the meeting. The
        following points were discussed:
      </div>
      <div className="mrm-main-table-container">
        <table className="mrm-main-table">
          <thead>
            <tr>
              <th className="mrm-th">Sl No</th>
              <th className="mrm-th">Points for discussion</th>
              <th className="mrm-th">Discussion details</th>
              <th className="mrm-th">Action Plan</th>
              <th className="mrm-th">Responsible</th>
              <th className="mrm-th">Target</th>
              <th className="mrm-th">Status</th>
            </tr>
          </thead>
          <tbody>
            {itemDetails && itemDetails.length > 0 ? (
              itemDetails.map((item, index) => (
                <tr key={index}>
                  <td className="mrm-td">{index + 1}</td>
                  <td className="mrm-td">
                    {item.points_for_discussion ||
                      item.points_for_discussion_text ||
                      item.discussion_points ||
                      "-"}
                  </td>
                  <td className="mrm-td">
                    {item.discussion_details ||
                      item.discussion_details_text ||
                      item.discussion ||
                      "-"}
                  </td>
                  <td className="mrm-td">
                    {item.action_plan ||
                      item.action_plan_text ||
                      item.action ||
                      "-"}
                  </td>
                  <td className="mrm-td">
                    {item.responsible ||
                      item.responsible_person ||
                      item.responsible_name ||
                      "-"}
                  </td>
                  <td className="mrm-td">
                    {item.target ||
                      item.target_date ||
                      item.target_period ||
                      "-"}
                  </td>
                  <td className="mrm-td">{item.status || "-"}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="7"
                  className="mrm-td"
                  style={{ textAlign: "center" }}
                >
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {(docRef || pageInfo) && (
        <div className="mrm-footer">
          {docRef && <div className="mrm-footer-left">Doc Ref: {docRef}</div>}
          {pageInfo && <div className="mrm-footer-right">{pageInfo}</div>}
        </div>
      )}
      <p className="invoice-system-generated-note">
        This is a system-generated document and does not require a signature.
      </p>
      <div className="invoice-buttons" style={{ paddingTop: "40px" }}>
        <DownloadButton
          tableData={invoiceTableData}
          fileName="minutes-of-mrm"
          downloadFormats={["excel", "pdf", "full-page-pdf"]}
          fullPageDownload={true}
          fullPageSelector=".mrm-invoice-container"
        />
      </div>
    </div>
  );
};
